import Core         from '@/core/Core';
import Product      from "@/domains/Products/Product";
import Title_ru_RU  from "@/core/misc/decorators/Title_ru_RU";
import TYPES        from "@/core/services/Changelogs/types";
import Price        from "@/core/types/Price";
import Partner from "@/domains/Partners/Partner";
import Currency from "@/domains/Currencies/Currency";
import BaseEntity from "@/core/misc/BaseEntity";

class BudgetPrice extends BaseEntity {
	  @Title_ru_RU('Продукт', TYPES.STRING)
	  product: Product;

	  @Title_ru_RU('Цена', TYPES.PRICE)
	  price: Price;

    @Title_ru_RU('Партнер', TYPES.PRICE)
    partner: Partner;

    @Title_ru_RU('Валюта', TYPES.STRING)
    currency: Currency|null;

    private _name: string;

    static fromServer(data: any, result = new BudgetPrice()): BudgetPrice {
      super.fromServer(data, result);

      result.product = Core.utils.hydrate(data.product, Product.fromServer)!;
      result.price = Core.utils.hydrate(data.price, Price.fromServer)!;
      result.partner = Core.utils.hydrate(data.partner, Partner.fromServer)!;
      result.currency = Core.utils.hydrate(data.currency, Currency.fromServer)!;
      result._name = result.product.name;

	  return result;
	  }

    static fromNew(): BudgetPrice {
      const budgetPrice = new BudgetPrice();

      budgetPrice.product = Product.getEmpty();
      budgetPrice.price = Price.fromEmpty();
      budgetPrice.partner = Core.currentPartner;
      budgetPrice._name = budgetPrice.product.name;
      budgetPrice.currency = Core.currentPartner?.country?.localCurrency ?? Core.config.localCurrency;

      return budgetPrice;
    }

    get name(): string {
      return this._name;
    }

    set name(value: string) {
      this._name = value;
    }

    toString() {
      return this.product?.name ? 'Бюджетная цена: ' + this.product?.name : 'Бюджетная цена';
    }
}

export default BudgetPrice;
